import React from 'react';
import Loading from '../../loadings';
import Add from './add';
import { Grid, Dropdown, Button } from 'semantic-ui-react';
import ReadCookie from '../../../functions/readcookies';
import $ from "jquery";
import Webserver from '../../../functions/server';
import Picklist from './conformmessage';

class Order extends React.Component {

  state = {
    data: [],
    addDialog: false,
    partcode: [],
    partcodeOption: [],
    items: [],
    removedData: []
  }

  componentDidMount() {
    this.getPlacedOrder();
  }
  componentDidUpdate(props) {
    if (props.customer != this.props.customer || props.branch != this.props.branch) {
      this.getPlacedOrder();
    }
  }

  getPartCode(discountlevelid) {
    let context = this;
    let customerPoints = 0;
    context.setState({
      load: true,
      message: 'Getting Partno!!!'
    });
    let data = (ReadCookie("branch"));
    
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    $.ajax({
      type: 'POST',
      data: { 'branch': branch_id, 'customer': context.props.customer, discountlevelid },
      url: Webserver() + 'purchasedetail/getpartcode.php',
      success: function(data) {
        console.log(data);
        console.log('0o0o00oooooooooooooooooooo');
        let items = [];
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          console.log(data);
          data.map((s) => {
            if (!s.mrp) {
            }
            else {
              items.push(s);
              customerPoints = s.customerpoints;
            }
          })
          context.setState({
            partcodeOption: items,
            customerPoints: customerPoints,
            partcode: items,
            addDialog: true
          })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setPartcode(data) {
    let context = this;
    var x = [];
    data.map((y) => {
        x.push({key: y.part_alias+'->'+y.spare_name+'->'+y.part_id, text: y.part_alias+'->'+y.spare_name, value: y.part_id});
    });
    context.setState({
      partcodeOption: x,
      partcode: data,
      addDialog: true
    });
  }

  getPlacedOrder() {
    this.setState({
      branch: this.props.branch,
      customer: this.props.customer
    })
  }

  handleClose() { this.setState({ addDialog: false, partcodeOption: [], items: [] }); }

  updateItems(data) {
    this.setState({ items: data })
  }

  handleClose1(data, type) {
    this.setState({
      addDialog: false, partcodeOption: [], picklistopen: true,
      picklistOrderid: data, type: type, items: [],
    });
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={7}><br/>
            <Button primary style={{display: this.props.viewEdit}} fluid onClick={this.getPartCode.bind(this, 0)}>Place Order</Button>
            { (this.state.partcodeOption.length > 0) ?
              (
                <Add ref={instance => { this.child2 = instance; }} customer={this.props.customer} dialog={this.state.addDialog}
                     items={this.state.items} updateItems={this.updateItems.bind(this)} otherCharge={false} customerName={this.props.customerName}
                     otherChargeAmount={0} otherChargeTax={0} customers={this.props.customers} otherChargeinfo={'Othercharge'}
                     executiveId={this.props.executiveId} removedData={this.state.removedData} customerPoints={this.props.customerPoints}
                     paymentmode={this.props.paymentmode} setPartcode={this.setPartcode.bind(this)} handleClose1={this.handleClose1.bind(this)}
                     handleClose={this.handleClose.bind(this)} branchState={this.props.branchState} partcode={this.state.partcode}
                     partcodeOption={this.state.partcodeOption} customerState={this.props.customerState} branch={this.props.branch}
                     type="add" customerTCS={this.props.customerTCS} getPartCode={this.getPartCode.bind(this)} />
              ) :
              (
                <div></div>
              )
            }
          </Grid.Column>
        </Grid>
        <Picklist type={this.state.type} picklistOrderid={this.state.picklistOrderid} picklistopen={this.state.picklistopen} closepicklist={ () => { this.setState({ picklistopen: false }) }} />
      </div>
    );
  }
}

export default Order;
